import * as auth from './auth/actions';
import * as user from './user/actions';
import * as audioPlayer from './audioPlayer/actions';
import * as noti from './noti/actions';
import * as dialog from './dialog/actions';
import * as request from './request/actions';
import * as synthesisRequest from './synthesisRequest/actions';
import * as voucher from './voucher/actions';
import * as banner from './banner/actions';
import * as language from './language/actions';
import * as voice from './voice/actions';
import * as device from './device/actions';
import * as deviceV2 from './deviceV2/actions';
import * as configTable from './configTable/actions';
import * as dubbingRequest from './dubbingRequest/actions';
import * as layout from './layout/actions';
import * as audioPreview from './audioPreview/actions';
import * as order from './order/actions';
import * as category from './category/actions';
import * as audioVoiceCloning from './audioVoiceCloning/actions';
import * as province from './province/actions';
import * as voiceVoiceCloning from './voiceVoiceCloning/actions';
import * as dictionary from './dictionary/actions';
import * as limitedFeaturesDialog from './limitedFeaturesDialog/actions';
import * as packageActions from './package/actions';
import * as projectActions from './project/actions';
import * as instantVoiceTraining from './instantVoiceTraining/actions';
import * as referralConfig from './referralConfig/actions';
import * as audioVoiceLibrary from './audioVoiceLibrary/actions';
import * as cancelReasonDialog from './cancelReasonDialog/actions';
import * as onboardingPopup from './onboardingPopup/actions';
import * as educatorsSurvey from './educatorsSurvey/actions';
import * as notification from './notification/actions';
import * as history from './history/actions';

export default {
  auth,
  user,
  audioPlayer,
  noti,
  dialog,
  request,
  synthesisRequest,
  voucher,
  banner,
  language,
  voice,
  device,
  deviceV2,
  configTable,
  dubbingRequest,
  layout,
  audioPreview,
  order,
  category,
  audioVoiceCloning,
  province,
  voiceVoiceCloning,
  dictionary,
  limitedFeaturesDialog,
  package: packageActions,
  project: projectActions,
  instantVoiceTraining,
  referralConfig,
  audioVoiceLibrary,
  cancelReasonDialog,
  onboardingPopup,
  educatorsSurvey,
  notification,
  history,
};
